export const subscribeToLocationChange = (cb: () => void) => {
  window.addEventListener('popstate', cb);
  return () => {
    window.removeEventListener('popstate', cb);
  };
};

export const updateLocationParams = (params: URLSearchParams) => {
  const search = params.toString();
  window.history.pushState({ search }, '', '?' + search);
  window.dispatchEvent(new Event('popstate'));
};

const getLocation = () => window.location;

export const getLocationSearch = () => {
  return getLocation().search;
};

export const getLocationPathname = () => getLocation().pathname;
